<template>
  <div class="container-fluid">
    <div id="dishes-list">

      <div class="row d-none d-md-flex">
        <div class="col-md-4 col-xl-3">

          <dish-group-selector
            ref="dishGroupSelector"
            @selectDishGroup="selectDishGroup">
          </dish-group-selector>

        </div>
        <div class="col-md-8 col-xl-9 pl-0">
          <div class="panel">

            <div class="row mb-2">
              <div class="col-6">
                <b-dropdown left>
                  <template #button-content>
                    <span class="mdi mdi-menu"></span> {{ $t('#TR-group') }}
                  </template>
                  <b-dropdown-item @click="onAddGroup">
                    {{ $t("#TR-add") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="editGroup">
                    {{ $t("#TR-edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="onDelGroup">
                    {{ $t("#TR-delete") }}
                  </b-dropdown-item>
                </b-dropdown>

                <!-- <b-button-group>
                  <b-button variant="secondary"
                            type="button"
                            class="text-nowrap border"
                            @click="onAddGroup">
                    <span class="mdi mdi-plus"></span> {{ $t("#TR-add") }}
                  </b-button>
                  <b-button variant="secondary"
                            type="button"
                            class="text-nowrap border"
                            @click="editGroup()">
                    <span class="mdi mdi-pencil"></span> {{ $t("#TR-edit") }}
                  </b-button>
                </b-button-group>-->

              </div>
              <div class="col-6 text-right">
                <b-button variant="success"
                          type="button"
                          class="mx-1 text-nowrap"
                          @click="addNewDish()">
                  <span class="mdi mdi-plus"></span> {{ $t("#TR-add-new-dish") }}
                </b-button>
              </div>

            </div>

            <transition name="fade3" mode="out-in">
              <div v-if="isEditGroup" class="row">
                <div class="col-12">
                  <edit-group :selected-dish-group="selectedDishGroup"
                              @save="onSaveGroup"
                              @close="isEditGroup = false">
                  </edit-group>
                </div>
              </div>
            </transition>

            <transition name="fade3" mode="out-in">
              <div v-if="isAddGroup" class="row">
                <div class="col-12">
                  <add-group :selected-dish-group="selectedDishGroup"
                             @save="onSaveNewGroup"
                             @close="isAddGroup = false">
                  </add-group>
                </div>
              </div>
            </transition>

            <div v-if="!dishLoader && dishList.length < 1"
                 class="text-center text-muted my-5 font-weight-bold">
              <span v-if="!selectedDishGroup">{{ $t("#TR-select-dish-group") }}</span>
              <span v-if="selectedDishGroup">{{ $t("#TR-no-data") }}</span>
            </div>

            <table v-if="dishList.length > 0"
                   class="table table-hover table-discounts">
              <thead>
                <tr class="font-weight-bold small">
                  <!--<th style="width: 40px;" class="text-center">#</th>-->
                  <th style="width: 40px;" class="text-center">{{ $t("#TR-code") }}</th>
                  <th style="width: 100px;" class="text-center">{{ $t("#TR-external-code") }}</th>
                  <th>{{ $t("#TR-name") }}</th>
                  <th class="text-right">{{ $t("#TR-main-price") }}</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="dish in dishList">
                  <tr v-if="!dish.deleted"
                      :key="dish.guid">
                    <td class="text-right text-muted font-weight-bold">
                      {{ dish.code }}
                    </td>
                    <td class="text-right text-muted font-weight-bold">
                      {{ dish.extCode }}
                    </td>
                    <td>{{ dish.name }}</td>
                    <td class="text-right font-weight-bold text-muted">
                      {{ dish['mainPrice'] ? dish['mainPrice'] : '&mdash;' }}
                    </td>
                    <td class="receipt-btn preview"
                        @click="dishView(dish)">
                      <span class="mdi mdi-eye-outline"></span>
                    </td>
                    <td class="receipt-btn edit"
                        @click="dishEdit(dish)">
                      <span class="mdi mdi-pencil"></span>
                    </td>
                    <td class="receipt-btn text-danger"
                        @click="onDishDelete(dish)">
                      <span class="mdi mdi-delete"></span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div v-if="dishLoader" class="small-loader">
            <i class="mdi mdi-rotate-right mdi-spin"></i>
          </div>

        </div>
      </div>

      <div class="row d-flex d-md-none">
        <div class="col-md-12 panel">
          <div class="row mb-3">
            <div class="col-6">

              <b-button-group>
                <b-button variant="success"
                          type="button"
                          class="text-nowrap border"
                          @click="openDishGroupSelector()">
                  <span class="mdi mdi-folder-outline"></span>
                  <!--{{ $t("#TR-group") }}-->
                </b-button>
                <b-button variant="secondary"
                          type="button"
                          class="text-nowrap text-center border"
                          @click="onAddGroup">
                  <span class="mdi mdi-folder-plus-outline"></span>
                </b-button>
                <b-button variant="secondary"
                          type="button"
                          class="text-nowrap text-center border"
                          @click="editGroup()">
                  <span class="mdi mdi-pencil"></span>
                </b-button>
                <b-button variant="danger"
                          type="button"
                          class="text-nowrap text-center border"
                          @click="onDelGroup()">
                  <span class="mdi mdi-delete"></span>
                </b-button>
              </b-button-group>

            </div>

            <div class="col-6 text-right">
              <b-button variant="success"
                        type="button"
                        class="mx-1 text-nowrap"
                        @click="addNewDish()">
                <span class="mdi mdi-plus-box-outline"></span>
                <span class="d-none d-md-inline"> {{ $t("#TR-add") }}</span>
              </b-button>
            </div>
          </div>

          <transition name="fade3" mode="out-in">
            <div v-if="isEditGroup" class="row">
              <div class="col-12">
                <edit-group :selected-dish-group="selectedDishGroup"
                            @save="onSaveGroup"
                            @close="isEditGroup = false">
                </edit-group>
              </div>
            </div>
          </transition>

          <transition name="fade3" mode="out-in">
            <div v-if="isAddGroup" class="row">
              <div class="col-12">
                <add-group :selected-dish-group="selectedDishGroup"
                           @save="onSaveNewGroup"
                           @close="isAddGroup = false">
                </add-group>
              </div>
            </div>
          </transition>

          <div v-if="dishList.length < 1" class="text-center text-muted my-5 font-weight-bold">
            <span v-if="!selectedDishGroup">{{ $t("#TR-select-dish-group") }}</span>
            <span v-if="selectedDishGroup">{{ $t("#TR-no-data") }}</span>
          </div>

          <div v-if="dishList.length > 0" class="row">
            <div class="col-12 dish-list-small">

              <template v-for="dish in dishList">
                <div :key="dish.guid"
                     class="dish-item shadow-sm">

                  <div class="h">
                    <div class="code text-success">
                      <!-- code: <span class="font-weight-bold">{{ dish['code'] }}</span>-->
                      <span class="badge mr-1 badge-success">
                        {{ $t("#TR-code") }}: {{ dish['code'] }}
                      </span><br>
                      <span class="badge mr-1 badge-secondary">
                        {{ $t("#TR-external-code") }}: {{ dish['extCode'] }}
                      </span>
                    </div>
                  </div>

                  <div class="name text-secondary">{{ dish['name'] }}</div>
                  <div class="price text-secondary text-right">
                    {{ $t("#TR-main-price") }}: <span class="font-weight-bold">
                      {{ dish['mainPrice'] ? dish['mainPrice'] : '&mdash;' }}</span>
                  </div>

                  <div class="dish-action">
                    <div class="dish-action-item delete"
                         @click="onDishDelete(dish)">
                      <span class="mdi mdi-delete"></span>
                    </div>
                    <div class="dish-action-item"
                         style="background: #5d4037;"
                         @click="dishEdit(dish)">
                      <span class="mdi mdi-pencil"></span>
                    </div>
                    <div class="dish-action-item bg-success"
                         @click="dishView(dish)">
                      <span class="mdi mdi-eye-outline"></span>
                    </div>
                  </div>
                </div>
              </template>

            </div>
          </div>
          <!--<table v-if="dishList.length > 0"
                           class="table table-hover table-discounts">
                        <thead>
                            <tr class="font-weight-bold small">
                                <th style="width: 40px;" class="text-center">#</th>
                                <th style="width: 40px;" class="text-center">Code</th>
                                <th>Name</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dish, idx) in dishList" :key="idx">
                                <td>{{ idx + 1 }}</td>
                                <td class="text-right text-muted font-weight-bold">{{ dish.code }}</td>
                                <td>{{ dish.name }}</td>
                                <td></td>
                                <td class="receipt-btn preview"
                                    @click="dishView(dish)">
                                    <span class="mdi mdi-eye-outline"></span>
                                </td>
                                <td class="receipt-btn edit"
                                    @click="dishEdit(dish)">
                                    <span class="mdi mdi-pencil"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>-->
        </div>
      </div>
    </div>

    <dish-group-selector-modal
      ref="dishGroupSelectorModal"
      @selectDishGroup="selectDishGroup">
    </dish-group-selector-modal>
    <dish-view-modal ref="dishViewModal" />
    <confirm-modal ref="confirmDeleteModal"
                   @confirm="deleteDish">
    </confirm-modal>
    <confirm-modal ref="confirmDeleteGroupModal"
                   @confirm="delGroup">
    </confirm-modal>
  </div>
</template>

<script>
  import { ApiDish, ApiDishGroup } from '@/services/api';
  import DishGroupSelectorModal from '@/views/WebEditor/Dishes/DishGroupSelectorModal';
  import DishGroupSelector from '@/views/WebEditor/Dishes/DishGroupSelector';
  import DishViewModal from '@/views/WebEditor/Dishes/DishView';
  import EditGroup from '@/views/WebEditor/Dishes/parts/EditGroup';
  import AddGroup from '@/views/WebEditor/Dishes/parts/AddGroup';
  import MSG from '@/services/notify';
  import ConfirmModal from '@/components/Confirm';

  export default {
    name: 'Dishes',

    components: {
      DishGroupSelector,
      DishGroupSelectorModal,
      DishViewModal,
      EditGroup,
      AddGroup,
      ConfirmModal
    },

    data() {
      return {
        dishList: [],
        selectedDishGroup: null,
        isEditGroup: false,
        isAddGroup: false,
        groupGuid: this.$route.params.group,
        selectorView: false,
        dishLoader: false
      };
    },

    mounted() {
      this.$store.commit('setPageTitle', '#TR-dishes');
      this.dishLoader = true;

      if (this.groupGuid) {
        this.$refs.dishGroupSelector.openCategory(this.groupGuid);
      } else {
        this.$refs.dishGroupSelector.openCategory();
      }
    },

    methods: {

      async getDishes(groupSifr) {
        const result = await ApiDish.list(groupSifr);
        if (result.error) {
          MSG.error(result.error, this);
        } else {
          this.dishList = result.data;
        }
      },

      openDishGroupSelector() {
        this.isEditGroup = false;
        this.isAddGroup = false;
        this.$refs.dishGroupSelectorModal.openDishGroupSelectorView();
      },

      async selectDishGroup(group) {
        this.dishLoader = true;
        this.isEditGroup = false;
        this.isAddGroup = false;
        this.selectedDishGroup = group;
        await this.getDishes(group.sifr);
        this.dishLoader = false;
      },

      addNewDish() {
        this.$router.push({
          name: 'dishesEdit',
          params: {
            group: this.selectedDishGroup.sifr
          }
        }).catch(() => {});
      },

      dishView(dish) {
        this.$refs.dishViewModal.openDishView(dish);
      },

      dishEdit(dish) {
        this.$router.push({
          name: 'dishesEdit',
          params: {
            guid: dish.guid,
            group: this.selectedDishGroup.sifr
          }
        }).catch(() => {});
      },

      editGroup() {
        this.isEditGroup = true;
        this.isAddGroup = false;
      },

      onAddGroup() {
        this.isAddGroup = true;
        this.isEditGroup = false;
      },

      async onSaveNewGroup(group) {
        await this.$refs.dishGroupSelector.openCategory(group.sifr);
        this.isAddGroup = false;
      },

      async onSaveGroup(group) {
        // this.selectedDishGroup = group;
        // this.$refs.dishGroupSelector.getDishGroup(group.parent);
        await this.$refs.dishGroupSelector.openCategory(group.sifr);
        this.isEditGroup = false;
      },

      onDishDelete(dish) {
        this.$refs.confirmDeleteModal.show({
          title: this.$t('#TR-delete'),
          message: this.$t('#TR-confirm-delete'),
          prop: dish
        });
      },

      async deleteDish(dish) {
        try {
          const result = await ApiDish.delete(dish.sifr);

          if (result.error) {
            MSG.error(result.error, this);
          } else {
            this.$set(dish, 'deleted', true);
            MSG.clear(this);
            MSG.success(this.$t('#TR-dish-deleted'), this);
          }
        } catch (e) {
          console.log(e.message);
        }
      },

      onDelGroup() {
        this.$refs.confirmDeleteGroupModal.show({
          title: this.$t('#TR-delete'),
          message: this.$t('#TR-confirm-delete')
        });
      },

      async delGroup() {
        try {
          const result = await ApiDishGroup.delete(this.selectedDishGroup.sifr);

          if (result.error) {
            MSG.error(result.error, this);
          } else {
            await this.$refs.dishGroupSelector.openCategory(this.selectedDishGroup.parent);
            MSG.clear(this);
            MSG.success(this.$t('#TR-dish-group-deleted'), this);
          }
        } catch (e) {
          console.log(e.message);
        }
      }

    }
  };
</script>

<style lang="stylus" scoped>
.dish-list-small {
    .dish-item {
        background: #fff
        border: 1px solid #efefef
        margin-bottom: 10px
        position: relative
        padding: 0 10px 10px 10px

        .h {
            display: flex
            .code {
                flex: auto
                padding-top: 10px;
            }
        }

        .name {
            font-weight: 600
            font-size: 16px
        }
        .price {
            font-weight: 600
            font-size: 14px
        }


        .dish-action {
            position: absolute;
            top: 4px;
            right: 4px;
            height: 32px;

            .dish-action-item {
                float: right
                width: 32px
                font-size: 18px
                line-height: 30px
                text-align: center
                background: #bbc2c3
                color: #fff
                border-radius: 5px
                margin-left: 5px
                cursor pointer

                &.delete {
                    background: #dc3545
                }

                &:hover {
                    background: c-accent
                }

                &.delete:hover {
                    background: #f00
                }
            }
        }
    }
}

  .darkmode {
    .dish-item {
      background: c-dark-bg
      border: c-dark-bg
    }
  }

</style>
